export const GET_ALL_BUILDINGS='GET_ALL_BUILDINGS';
export const GET_MANAGER_BUILDING='GET_MANAGER_BUILDING';
export const BED_SUMMARY_PIECHART='BED_SUMMARY_PIECHART';
export const GET_BEDS_BY_BUILDINGID='GET_BEDS_BY_BUILDINGID';
export const SUCCESS_RESPONSE='SUCCESS_RESPONSE';
export const FAILURE_RESPONSE='FAILURE_RESPONSE';
export const GET_BEDS_BY_COLOR_FILTERS='GET_BEDS_BY_COLOR_FILTERS';
export const LOADING='LOADING';
export const AVAILABEL_BEDSBY_BUILDINGID="AVAILABEL_BEDSBY_BUILDINGID";
export const GET_BEDINFO="GET_BEDINFO"
export const CHANGE_BED="CHANGE_BED"
export const FORCE_CHECKOUT="FORCE_CHECKOUT"
export const EDIT_DUE="EDIT_DUE"
export const MAKE_FALSE="MAKE_FALSE"
export const CANCEL_CHECKOUT='CANCEL_CHECKOUT'
export const BUILDING_SUMMARY="BUILDING_SUMMARY"
